import { map, of } from 'rxjs';
import { memo } from '@polkadot/api-derive/util';
import { U8aFixed } from '@polkadot/types-codec';
export const u64FromCurrency = (currency) => {
    const buf = Buffer.from(currency.toLowerCase());
    const size = buf.length;
    return buf.reduce((val, digit, i) => {
        const exp = BigInt(size - 1 - i);
        return BigInt(val) + BigInt(256) ** exp * BigInt(digit);
    }, BigInt(0));
};
const TOKENS = ['eq'];
export const createDerives = (tokens) => tokens.reduce((prev, token, i) => {
    const isNative = !i;
    return {
        ...prev,
        [token]: { customAccount: (instanceId, api) => {
                const { registry } = api;
                const asset = u64FromCurrency(token);
                return memo(instanceId, (address) => api.query.system.account(address).pipe(map((v) => {
                    const data = v.data;
                    const miscFrozen = isNative ? data.asV0.lock : registry.createType('u128', 0);
                    const feeFrozen = miscFrozen;
                    const reserved = registry.createType('u128', 0);
                    const entry = data.asV0.balance.find(([assetId]) => {
                        return assetId.toBigInt() === asset;
                    });
                    const balance = entry?.[1];
                    const free = balance?.isPositive
                        ? balance.asPositive
                        : registry.createType('u128', 0);
                    return {
                        feeFrozen, free, miscFrozen, reserved
                    };
                })));
            },
            customLocks: (instanceId, api) => {
                const { registry } = api;
                return memo(instanceId, (address) => isNative
                    ? api.query.system.account(address).pipe(map((v) => {
                        const data = v.data;
                        return [{
                                amount: data.asV0.lock,
                                id: new U8aFixed(registry),
                                reasons: ''
                            }];
                    }))
                    : of([]));
            } }
    };
}, {});
const definitions = {
    derives: createDerives(TOKENS),
    instances: { balances: TOKENS }
};
export default definitions;
